import * as React from "react";
import "./index.css";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { signin } from "../../store/actions/userActions";
import { useEffect } from "react";
import Loader from "../../Components/Loader";
import MessageBox from "../../Components/MessageBox";
import { useNavigate } from "react-router-dom";
export default function FormPropsTextFields(props) {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userSignin = useSelector((state) => state.userSignin);
  const { userInfo, loading, error } = userSignin;

  const { search } = useLocation();
  const redirectInUrl = new URLSearchParams(search).get("redirect");
  const redirect = redirectInUrl ? redirectInUrl : "/";

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(signin(email, password));
  };

  useEffect(() => {
    if (userInfo) {
      navigate(redirect);
    }
  }, [navigate, redirect, userInfo]);

  return (
    <>
      <div className="imageOverlayContainerSignin">
        <h1>Signin</h1>
        <div className="colorOverlaySignin"></div>
      </div>
      <div className="signinContainer container-fluid my-5 container">
        {error && <MessageBox variant="danger">{error}</MessageBox>}
        {loading ? (
          <Loader></Loader>
        ) : (
          <form action="" onSubmit={submitHandler}>
            <div className="loginFields d-flex justify-content-center">
              <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                <div>
                  <TextField
                    id="outlined-basic"
                    label="Email"
                    variant="outlined"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    sx={{ mt: 2, width: "30ch" }}
                  />{" "}
                  <br />
                  <TextField
                    id="outlined-password-input"
                    label="Password"
                    type="password"
                    value={password}
                    autoComplete="current-password"
                    sx={{ mt: 2, width: "30ch" }}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <div className="signinButton d-flex justify-content-center mt-4">
                    <Button
                      type="submit"
                      variant="contained"
                      className="w-100 bg-warning text-dark"
                    >
                      Sign In
                    </Button>
                  </div>
                  <div className="signinNewUser d-flex justify-content-start mt-4">
                    New User? &nbsp;{" "}
                    <Link
                      to={`/register?redirect=${redirect}`}
                      className="tdnone"
                    >
                      Click here to Register
                    </Link>
                  </div>
                </div>
              </Box>
            </div>
          </form>
        )}
      </div>
    </>
  );
}
